export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchDocumentList = async (payload) => {
  try {
    const response = await fetch(`${BASE_URL}document/document_list`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      console.log("Network response was not ok");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("Fetch error:", error);
    throw error;
  }
};

export const refundAPI = async (payload , URL) => {
  try {
    const response = await fetch(`${BASE_URL}${URL}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      console.log("Network response was not ok");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("Fetch error:", error);
    throw error;
  }
};
